import useReveal from "@/hooks/useReveal";

const SPECS = [
  { label: "Frame", value: "18k gold-tone metal alloy" },
  { label: "Lens", value: "CR-39 anti-glare, 100% UVA/UVB" },
  { label: "Left Eye", value: "Custom Africa-shaped contour" },
  { label: "Right Eye", value: "Editorial hexagonal cut" },
  { label: "Temples", value: "Matte black acetate" },
  { label: "Edition", value: "Limited to 300 worldwide" },
];

export default function ProductDetails() {
  const r = useReveal();
  return (
    <section
      data-testid="product-details-section"
      className="relative bg-[#070707] py-24 md:py-36"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div
          ref={r.ref}
          className={`reveal ${r.inView ? "in-view" : ""}`}
        >
          <div className="flex items-end justify-between flex-wrap gap-4 mb-16">
            <div>
              <span className="font-label text-[#d4af37]">— The Craft —</span>
              <h2 className="mt-4 font-display text-[clamp(1.8rem,4vw,3.4rem)] leading-tight text-white max-w-2xl">
                Built for collectors who measure value in{" "}
                <span className="font-editorial italic gold-text-gradient">
                  detail.
                </span>
              </h2>
            </div>
            <span className="font-editorial italic text-[#9a9a93] text-lg">
              · 001 / The Africa Frame™
            </span>
          </div>

          <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {SPECS.map((spec, i) => (
              <li
                key={spec.label}
                className={`border-b border-[#1f1f1f] py-8 px-2 md:px-6 group transition-colors hover:bg-[#0c0c0c] ${
                  i % 3 !== 2 ? "lg:border-r lg:border-[#1f1f1f]" : ""
                }`}
                data-testid={`product-spec-${i}`}
              >
                <span className="font-label text-[#8a8a85] group-hover:text-[#d4af37] transition-colors">
                  {spec.label}
                </span>
                <p className="mt-3 font-display text-white text-xl leading-snug">
                  {spec.value}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
